/**
 * Light, dark, or whatever the machine is set to. The stored choice is applied in
 * index.html before first paint; this is only the control that changes it.
 */
export type Theme = "system" | "light" | "dark";

const KEY = "trellis-theme";

export function readTheme(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(t: Theme): void {
  const root = document.documentElement;
  if (t === "system") delete root.dataset.theme;
  else root.dataset.theme = t;
  try {
    if (t === "system") localStorage.removeItem(KEY);
    else localStorage.setItem(KEY, t);
  } catch {
    // A locked-down browser still gets the change for this page load.
  }
}
